module.exports = __webpack_public_path__ + "static/media/avatar.7916fd55.jpg";